import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { event, pricing } from '../data/masterclass';
const EASE = [0.23, 1, 0.32, 1] as const;
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.9;
      const nearEnd = window.scrollY + window.innerHeight > document.documentElement.scrollHeight - 900;
      setVisible(past && !nearEnd);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-139" data-mp="3kmah4c5x2p4p">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/30 bg-ink/95 backdrop-blur" data-id="element-140" data-mp="3kkzfahw17rg8">
          <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-3 px-6 py-3.5 sm:flex-row sm:justify-between" data-id="element-141" data-mp="765l79mkdcjo">
            <p className="text-center text-xs font-semibold uppercase tracking-[0.14em] text-white/70 sm:text-left" data-id="element-142" data-mp="gvp4gge6v8f2">
              {event.dateLabel} · {event.timeLabel} · Live on Zoom
            </p>
            <div className="flex w-full gap-3 sm:w-auto" data-id="element-143" data-mp="pw3ozdjbwjhi">
              {pricing.map(tier => <a key={tier.name} href={tier.url} target="_blank" rel="noopener noreferrer" className={`inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-full px-5 py-3 text-xs font-bold uppercase tracking-[0.12em] transition-[transform,background-color,color] duration-200 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:flex-none ${tier.featured ? 'bg-gold text-ink hover:bg-gold-pale' : 'border border-gold/60 text-gold hover:bg-gold hover:text-ink'}`} data-id="element-144" data-mp="lv1zhof7rlsq">
                  {tier.featured ? 'All 3 classes — $250' : 'Class 1 — $97'}
                </a>)}
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}